<template>
  <div
    id="burguer-menu"
    :class="{ active: isBurgerActive }"
  >
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>

<script>
export default {
  name: "menu",
  props: {
      isBurgerActive: Boolean
  }
};
</script>

<style lang="scss" scoped>
#burguer-menu {
  display: inline-block;
  cursor: pointer;
}

.bar1,
.bar2,
.bar3 {
  width: 35px;
  height: 5px;
  background-color: #fa6940;
  margin: 6px 0;
  transition: 0.4s;
}

.active {
  .bar1 {
    -webkit-transform: rotate(-45deg) translate(-9px, 6px);
    transform: rotate(-45deg) translate(-9px, 6px);
    background-color: #f7fafcff;
  }

  .bar2 {
    opacity: 0;
  }

  .bar3 {
    -webkit-transform: rotate(45deg) translate(-8px, -8px);
    transform: rotate(45deg) translate(-8px, -8px);
    background-color: #f7fafcff;

  }
}

@media only screen and (max-width: 500px) {
  #burger-menu {
    display: inline-block;
  }
}
</style>
